<template>
  <div class="PVerify">
    <div class="PVerify__header">
      <span>Input: Get Patient Benefits (PVerify)</span>
      <v-btn icon @click="extend = !extend"><v-icon> {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn>
    </div>
    <div v-if="extend">
      <div v-if="isValidJson" class="PVerify__body">
        <div>
          <p>{{ inputObject.firstName }} {{ inputObject.lastName }}</p>
          <p><span style="font-weight: bold">Day of Birth:</span> {{ inputObject.dob }}</p>
          <p><span style="font-weight: bold">Member ID:</span> {{ inputObject.memberId }}</p>
          <p><span style="font-weight: bold">Insurance Company:</span> {{ inputObject.insuranceCompany }}</p>
        </div>
        <json-viewer
            :expand-depth=0
            :value="inputObject"
            style="white-space: pre-line; border-radius: 15px; width: 100%"
        ></json-viewer>
      </div>
      <div v-if="!isValidJson" style="padding: 10px">
        <v-progress-circular
            :size="20"
            :width="1"
            color="primary"
            indeterminate
        />
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import VueLoaders from 'vue-loaders';

import JsonViewer from 'vue-json-viewer';
import Vue from "vue";

Vue.use(VueLoaders);

export default {
  name: 'default-action-input',
  components: { JsonViewer },
  props: {
    input: {},
    name: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
    };
  },
  computed: {
    inputObject() {
      return typeof this.input !== 'string' ? this.input : JSON.parse(this.input)
    },
    isValidJson() {
      try {
        if(typeof this.input !== 'string') {
          return true;
        }
        JSON.parse(this.input);
        return true
      } catch (e) {
        return false;
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import '../index';
</style>
